import type { Components, Theme } from '@mui/material';

export const MuiTableRow: Components<Theme>['MuiTableRow'] = {
  styleOverrides: {
    head: { height: 40 },
    root: { height: 64 },
  },
};
